import { sortBy } from "lodash";

import { GetPaymastersQuery, PaymasterScore } from "../graphql/generated.ts";
import { toHumanReadable } from "../utils/string.ts";

export type Paymaster = GetPaymastersQuery["paymasters"]["data"][0];

export const paymasterScoreOptions = sortBy(
  Object.values(PaymasterScore).map((value) => {
    return { value, label: toHumanReadable(value) };
  }),
  "label"
);
